import React from "react";
import { CodeBlock } from "../ui.js";
import CALLBACK1 from "../../../assets/images/callback1.png";
import CALLBACK2 from "../../../assets/images/callback2.png";

// /document-api?i=callback
export default function Callback() {
  return (
    <>
              <h5 className="fw-bold">1. Submit Your Callback URL</h5>
              <ul>
                <li>
                  1.1 You can provide the callback URL to our administrator, who
                  will set it up for you.
                </li>
                <li>
                  1.2 You can also configure the callback URL yourself under the
                  menu <strong>Settings &gt; Payment Information</strong>
                </li>
              </ul>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={CALLBACK1}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={CALLBACK2}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>

              <p>
                The callback URL should use <strong>HTTPS</strong> for security
                purposes.
              </p>

              <p>The callback will only be triggered when:</p>
              <ul>
                <li>
                  The transaction status is <strong>"success"</strong>
                </li>
                <li>
                  The transaction status is <strong>"cancel"</strong>
                </li>
                <li>
                  The transaction status is <strong>"mismatch"</strong>
                </li>
                <li>
                  The transaction status is <strong>"refund"</strong>
                </li>
              </ul>

              <h5 className="fw-bold">2. Await Callback Trigger</h5>
              <p>
                Whenever the transaction reaches success, cancel, mismatch or
                refund, the system automatically makes a POST request to your
                provided callback URL.
              </p>
              <p>
                You do not need to poll the API or check status manually — the
                system will notify you in real time.
              </p>
              <h5 className="fw-bold">3. Handle Incoming Callback Data</h5>
              <p>
                Your server should accept a POST request with JSON body, and
                process it securely.
              </p>
              <h5 className="fw-bold mb-3">Method</h5>
              <div className="w-100 rounded-3 px-3 py-2 bg-light mb-3 hpx-40">
                <span>POST</span>
              </div>
              <div>
                <h5 className="fw-bold mb-3">Response</h5>
                <CodeBlock text={global.callback} />
              </div>
              <div className="mb-3">
                <h5 className="fw-bold mb-3">Status</h5>
                <ul>
                  <li>
                    <div className="d-flex">
                      <div className="wpx-100 fw-bold">success</div>
                      <span>Payment completed successfully</span>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex">
                      <div className="wpx-100 fw-bold">cancel</div>
                      <span>
                        Payment was canceled or the transaction expired
                      </span>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex">
                      <div className="wpx-100 fw-bold">mismatch</div>
                      <span>
                        Bank account information does not match the registered
                        details
                      </span>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex">
                      <div className="wpx-100 fw-bold">refund</div>
                      <span>Payment has been refunded to the customer</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="mb-3">
                <h5 className="fw-bold mb-3">status_reason</h5>
                <ul>
                  <li>Transaction success.</li>
                  <li>Transaction rejected by bank.</li>
                  <li>Transaction mismatch bank information.</li>
                  <li>Transaction expired.</li>
                </ul>
                <p>Other values may contain the bank or gateway remark text.</p>
              </div>
              <h5 className="fw-bold">4. Respond to Callback Request</h5>
              <p>
                To acknowledge that you received the callback successfully, your
                server should respond with:
              </p>
              <div className="w-100 rounded-3 px-3 py-2 bg-light mb-3 hpx-40">
                HTTP 200 OK
              </div>
              <ul>
                <li>
                  Only <b>HTTP 200</b> counts as delivered (201/204 are treated
                  as failures). The request times out after 60 seconds.
                </li>
                <li>
                  Failed callbacks for <b>success</b> and <b>cancel</b>{" "}
                  transactions are retried every 3 minutes for up to 1 hour after
                  the transaction was created. <b>mismatch</b> and{" "}
                  <b>refund</b> callbacks are not retried.
                </li>
                <li>
                  Callbacks are not signed. Confirm the status with{" "}
                  <b>get transactions</b> before crediting the customer.
                </li>
              </ul>
              <p>
                It's important to log and verify the payload to ensure accurate
                transaction tracking.
              </p>
    </>
  );
}
